import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ValuationsRoutingModule } from './valuations-routing.module';
import { ValuationsComponent } from './valuations.component';
import { HeaderModule } from '../shared/components/header/header.module';
import { FooterModule } from '../shared/components/footer/footer.module';
import { NavigationModalModule } from '../shared/components/navigation-modal/navigation-modal.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';

@NgModule({
  declarations: [
    ValuationsComponent
  ],
  imports: [
    CommonModule,
    ValuationsRoutingModule,
    FooterModule, 
    HeaderModule, 
    NavigationModalModule,
    FormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule
  ],
  exports: [
    ValuationsComponent
  ]
})
export class ValuationsModule { }
